import { render, staticRenderFns } from "./DeliveryQualityInspectionPart.vue?vue&type=template&id=16f51d97&"
import script from "./DeliveryQualityInspectionPart.vue?vue&type=script&lang=js&"
export * from "./DeliveryQualityInspectionPart.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryQualityInspectionPart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports